module.exports = "/_next/static/images/d2cbd34b31acc46df147e02cb58b81fc-row-2-transfer.svg.webp";